// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jobList_root__OeooR {\n  display: flex;\n  width: calc(100% - 10px);\n  background: #fafafa;\n  justify-content: center;\n  margin-left: 5px; }\n\n@media screen and (max-width: 1360px) {\n  .jobList_company-info__9Zf7W {\n    width: calc(100% - 100px); }\n  .jobList_root__OeooR .jobList_info__hDBL9 {\n    width: calc(100% - 100px); } }\n", ""]);
// Exports
exports.locals = {
	"root": "jobList_root__OeooR",
	"company-info": "jobList_company-info__9Zf7W",
	"info": "jobList_info__hDBL9"
};
module.exports = exports;
